<template>
  <div class="select-wrap">
    <div class="hd">
      <h3 class="pf-medium">选择游玩日期</h3>
    </div>
    <div class="bd">
      <div
        class="cell cdlr"
        v-for="(item, index) in dateList"
        :key="index"
        :class="{
          disabled: !item.price || !item.inventory,
          checked: item === dateChecked
        }"
        @click="toggleChecked(item)"
      >
        <span class="date">{{
          item | localDate(getDateToday, getDateTomorrow)
        }}</span>

        <span class="prc" v-if="item.price && item.inventory">
          <template v-if="isJifen"
            ><small>{{ item.price }}<wbr />积分</small></template
          >
          <template v-else
            ><small>&yen;</small
            ><b>{{
              $$cent2yuan(
                item.customerPrice != null ? item.customerPrice : item.price,
                'yuan'
              )
            }}</b></template
          >
        </span>
        <span class="noavl" v-else-if="item.loading">-</span>
        <span class="noavl" v-else>不可订</span>

        <small class="inventory" v-if="item.inventory && item.inventory <= 10"
          >剩余{{ item.inventory }}</small
        >
        <img
          v-if="
            item === dateChecked &&
            item.customerPrice != null &&
            getUserTag(item)
          "
          class="user-tag"
          :src="getUserTag(item)"
        />
      </div>
      <div class="cell more" @click="showPopup">
        <span class="l">更多<br />日期</span>
        <i class="r iconfont icon-arrow-right"></i>
      </div>
    </div>

    <Popup v-model="isShowPopup" class="popup" position="bottom">
      <top
        title="选择游玩日期"
        :evtBack="true"
        :isPop="true"
        @back="back"
      ></top>
      <calendar
        class="calendar"
        :isJifen="isJifen"
        :availDatePrice="availDatePrice"
        @useDate="replaceDate"
        @dftDate="dftDate"
      ></calendar>
    </Popup>
  </div>
</template>

<script>
import { Popup } from 'mint-ui'
import top from '@/components/common/top'
import calendar from './tripCalendar'
import iconUserGold from '@/assets/images/icon_user_gold2.png'
import iconUserPregnant from '@/assets/images/icon_user_pregnant2.png'
import iconUserCertify from '@/assets/images/icon_user_certify2.png'

export default {
  data() {
    return {
      MAX_LENGTH: 3,
      isShowPopup: false,
      dateList: [],
      dateChecked: null
    }
  },
  created() {
    const d0 = this.getDateOf(0)
    const d1 = this.getDateOf(1)
    const d2 = this.getDateOf(2)
    // 在日历价格loaded前数据不可用，此时用“-”作占位符
    d0.loading = true
    d1.loading = true
    d2.loading = true
    this.dateList.push(d0, d1, d2)
  },
  mounted() {},
  methods: {
    showPopup() {
      this.isShowPopup = true
    },
    hidePopup() {
      this.isShowPopup = false
    },
    back() {
      this.hidePopup()
    },
    replaceDate(date) {
      if (this.dateList.indexOf(date) !== -1) {
        console.log('selected date already exists')
      } else {
        // 替换已选3天日期中的最后一天
        // 如果可用日历不足3天，则直接关闭Popup
        if (this.dateList.length === 3) {
          this.dateList.splice(this.dateList.length - 1, 1, date)
        }
      }
      this.toggleChecked(date)
      // 为了让用户能看到自己选择了哪个日期，延迟一会儿再关闭Popup
      setTimeout(() => {
        this.isShowPopup = false
      }, 10)
    },
    dftDate(dft) {
      this.dateList.splice(0, 3, ...dft)
    },
    getDateOf(offset = 0) {
      const t = new Date().getTime() + 24 * 3600 * 1000 * offset
      const d = new Date(t)
      return {
        year: d.getFullYear(),
        month: d.getMonth() + 1,
        date: d.getDate(),
        day: d.getDay()
      }
    },
    getDateToday() {
      return this.getDateOf()
    },
    getDateTomorrow() {
      return this.getDateOf(1)
    },
    getUserTag(item) {
      if (item.customerType == 1) {
        return iconUserGold
      } else if (item.customerType == 2) {
        return iconUserPregnant
      } else if (item.customerType == 3) {
        return iconUserCertify
      }
      return ''
    },
    toggleChecked(item) {
      if (!item.price) {
        console.log('no price')
        return
      }
      if (!item.inventory) {
        console.log('no inventory')
        return
      }
      if (this.dateChecked === item) {
        console.log('already selected')
        return
      }
      this.dateChecked = item
      this.$emit('useTripDate', this.dateChecked)
    }
  },
  filters: {
    localDate(date, f1, f2) {
      let badge = ''
      const today = f1()
      const tomorrow = f2()
      const weekTpl = ['日', '一', '二', '三', '四', '五', '六']
      if (
        date.date === today.date &&
        date.month === today.month &&
        date.year === today.year
      ) {
        badge = '今天'
      } else if (
        date.date === tomorrow.date &&
        date.month === tomorrow.month &&
        date.year === tomorrow.year
      ) {
        badge = '明天'
      } else if (date.year !== today.year) {
        badge = '明年'
      } else {
        const w = weekTpl[date.day % 7]
        badge = `周${w}`
      }
      const MM = `0${date.month}`
      const DD = `0${date.date}`
      return `${badge}${MM.substr(-2)}-${DD.substr(-2)}`
    }
  },
  props: {
    availDatePrice: {
      type: Array,
      default: () => {
        return []
      }
    },
    isJifen: {
      type: Boolean,
      required: false
    },
    isNoCalendar: {
      type: Number,
      default: 0
    }
  },
  components: {
    top,
    Popup,
    calendar
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import '~assets/css/mixin.scss';

.select-wrap {
  @include border(bottom, #eeeeee);
  & > .hd {
    padding-top: rem(26px);
    h3 {
      font-size: rem(30px);
      color: #121212;
    }
  }
  & > .bd {
    display: flex;
    padding: rem(24px) 0;

    .cell {
      position: relative;
      display: flex;
      margin-right: rem(16px);
      border: rem(3px) solid #e7e7e7;
      border-radius: rem(8px);
      &.cdlr {
        width: rem(164px);
        height: rem(116px);
        flex: 0 0 rem(164px);
        margin-right: rem(16px);
        padding-left: rem(24px);
        background-color: #fff;
        flex-direction: column;
        justify-content: center;
        .date {
          font-size: rem(26px);
          margin-bottom: rem(4px);
          color: #121212;
        }
        .prc {
          color: #ff4b4b;
          font-size: rem(32px);
          margin-bottom: rem(2px);
          small {
            font-size: rem(24px);
            margin-right: rem(4px);
          }
          b {
            font-weight: normal;
          }
        }
        .inventory {
          font-size: rem(18px);
          color: #ff4b4b;
        }
        .user-tag {
          position: absolute;
          left: 0;
          top: rem(-11px);
          display: block;
          width: auto;
          height: rem(24px);
        }
        &.disabled {
          background-color: #e7e7e7;
          .date,
          .noavl {
            color: #262626;
            font-size: rem(26px);
          }
        }
        &.checked {
          position: relative;
          border: 1px solid #ff5900;
          background-color: #fff5f0;
          &::after {
            content: '';
            position: absolute;
            right: 0;
            bottom: 0;
            width: rem(30px);
            height: rem(26px);
            margin-right: -1px;
            margin-bottom: -1px;
            background-image: url('~@/assets/images/order/date_check.png');
            background-size: contain;
          }
        }
      }
      &.more {
        width: rem(114px);
        height: rem(116px);
        flex: 0 0 rem(114px);
        display: flex;
        justify-content: center;
        align-items: center;
        .l {
          font-size: rem(24px);
          color: #121212;
          line-height: rem(36px);
          margin: 0 rem(6px);
        }
        .r {
          font-size: rem(22px);
        }
      }
    }
  }
}

.popup {
  width: 100%;
  height: 100%;
  background-color: #f4f4f4;
  z-index: 999;
  display: flex;
  flex-direction: column;
  .calendar {
    flex: 1;
  }
}
</style>
